import React from "react"

import "./FillSpace.sass"

export default function FillSpace() {
	return <div className="fill-space" />
}
